import React, { Component } from 'react';
import { Modal, Form, Card, Container, Col, Button, Row } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown';
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";

import { components } from 'react-select'
import { MenuItem } from 'react-bootstrap';
import { log } from 'logrocket';
import Select from "react-select";
import S from "./buildingFinanceStyles";
import "./_buildingCreationModal.scss";
import { canEdit } from "../../../utils/modulePermissions";

// /building-creation → "Hostel_Buildings". Match on module_key only.
//
// The three sections that open this modal already gate their openers, so these are
// backstops on the writes themselves. They use the SILENT canEdit() rather than
// requireEdit() because this modal renders no Access Denied modal of its own — the denial
// is surfaced by the gated opener.
const HOSTEL_BUILDINGS_MODULE = ["Hostel_Buildings"];

const ADD_STUDENT_ALLOTMENT_DETAILS = gql`
  mutation(
    $params:AddStudentAllotmentDetails
    ) {
        addStudentAllotmentDetails(
        params: $params
     )
  }
`;

// Searchable single-select styling for the Building Name dropdown — matches the
// Finance-style form inputs (rounded 10px, soft border, indigo focus/accent).
const buildingSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 42,
        borderRadius: 10,
        borderWidth: 1.5,
        borderColor: state.isFocused ? "#6366f1" : "#e5e7eb",
        backgroundColor: state.isDisabled ? "#f1f5f9" : (state.isFocused ? "#fff" : "#f9fafb"),
        boxShadow: state.isFocused ? "0 0 0 3px rgba(99,102,241,0.12)" : "none",
        fontSize: 14,
        "&:hover": { borderColor: state.isFocused ? "#6366f1" : "#c7d2fe" },
    }),
    placeholder: (base) => ({ ...base, color: "#9aa3b2", fontSize: 14 }),
    menu: (base) => ({ ...base, borderRadius: 12, overflow: "hidden", boxShadow: "0 8px 24px rgba(15,23,42,0.12)" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        fontSize: 13,
        fontWeight: 500,
        color: state.isSelected ? "#fff" : "#334155",
        backgroundColor: state.isSelected ? "#6366f1" : state.isFocused ? "#eef2ff" : "#fff",
        ":active": { backgroundColor: "#e0e7ff" },
    }),
    dropdownIndicator: (base) => ({ ...base, color: "#6366f1" }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: "#e5e7eb" }),
};

// Larger styled select for the "Allocate Students" (Bed) dropdowns.
const studentSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 46,
        borderRadius: 12,
        borderWidth: 1.5,
        borderColor: state.isFocused ? "#6366f1" : "#e5e7eb",
        backgroundColor: "#fff",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(99,102,241,0.12)" : "none",
        fontSize: 14,
        "&:hover": { borderColor: state.isFocused ? "#6366f1" : "#c7d2fe" },
    }),
    valueContainer: (base) => ({ ...base, padding: "2px 12px" }),
    placeholder: (base) => ({ ...base, color: "#9aa3b2", fontSize: 14 }),
    singleValue: (base) => ({ ...base, color: "#1f2937", fontWeight: 600 }),
    menu: (base) => ({ ...base, borderRadius: 12, overflow: "hidden", boxShadow: "0 8px 24px rgba(15,23,42,0.12)" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        fontSize: 13,
        fontWeight: 500,
        color: state.isSelected ? "#fff" : "#334155",
        backgroundColor: state.isSelected ? "#6366f1" : state.isFocused ? "#eef2ff" : "#fff",
        ":active": { backgroundColor: "#e0e7ff" },
    }),
    dropdownIndicator: (base) => ({ ...base, color: "#6366f1" }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: "#e5e7eb" }),
};
const DELETE_EXISTING_ROOM_STUDENTS = gql`
mutation(
  $params:DeletedStudents  
  ) {
    deleteExistingRoomStudents(
      params: $params
   )
}
`;

const options = [
    { label: "Customer", value: "Customer" },
    { label: "Country", value: "Country" },
    { label: "Prefecture", value: "Prefecture" },
    { label: "Site", value: "Site" }
];

class AddBuildingModal extends Component {
    constructor() {
        super();
        this.state = {
            branchSearch: "",
            branchError: "",

            buildingSearch: "",
            buildingError: "",

            floorSearch: "",
            floorError: "",

            roomSearch: "",
            roomError: "",

            dataClear: 1,
            studentFilterData: [],
            defaultvalue: 0,
            getBuildings: [],
            getFloors: [],
            getRooms: [],
            capacityDetails: [],
            capacityCount: 0,
            showInputFields: false,
            studentnameSearchval: [],
            submitError: "",
            multiStuSubmitError: "",
            submitted: false,
            loadingSpin: 0,
            noChangeMsg: "",
        }
    }

    handleAllocationChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "branchSearch") {
            if (value != 0 && value != "") {
                this.setState({
                    branchSearch: value,
                    studentFilterData: [],
                    branchError: "",
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getBuildings: [],
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
                this.getBuildingCreationDetails(value);
                this.getAllotmentStudents(value);
            } else {
                this.setState({
                    branchSearch: "",
                    studentFilterData: [],
                    branchError: "",
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getBuildings: [],
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
            }

        }
        if (name == "buildingSearch") {
            let getFloors = []
            if (value != 0 && value != "") {
                getFloors = this.state.getBuildings.filter((item) => item.hostel_building_id == value)[0].floors_details
                console.log("getFloors", getFloors);


                this.setState({
                    buildingSearch: value,
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: getFloors,
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false

                })
                return ""
            } else {
                this.setState({
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
            }

        }
        if (name == "floorSearch") {
            let getRooms = []
            if (value != 0 && value != "") {
                console.log("floorFilterData", this.state.getFloors, value);

                getRooms = this.state.getFloors.filter((item) => item.floor_id == value)[0].rooms_details;
                console.log("floorFilterData", getRooms);

                this.setState({
                    floorSearch: value,
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getRooms: getRooms,
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
                return ""
            } else {
                this.setState({
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })

            }
        }
        if (name == "roomSearch") {
            let capacityDetails = []
            console.log("val", this.state.getRooms);
            if (value != 0) {
                capacityDetails = this.state.getRooms.filter((item) => item.room_id == value);
                let details = [];
                console.log("floorFilterData", capacityDetails, this.state);

                if (capacityDetails[0].capacity_details.length > 0) {

                    let uniquecapacityDetails = [];

                    if (capacityDetails[0].capacity_details.length > 0) {
                        uniquecapacityDetails = capacityDetails[0].capacity_details.filter((item, index, array) => {
                            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                        })
                    }

                    console.log("details", uniquecapacityDetails);
                    if (capacityDetails[0].capacityCount == uniquecapacityDetails.length) {


                        uniquecapacityDetails.map((item) => {
                            details.push({ value: `${item.edu_student_id}`, label: this.studentLabel(item.edu_student_id) })
                        })

                    } else {
                        let laggingCapacitylength = capacityDetails[0].room_capacity - uniquecapacityDetails.length;
                        uniquecapacityDetails.map((item) => {
                            details.push({ value: `${item.edu_student_id}`, label: this.studentLabel(item.edu_student_id) })
                        })
                        Array.from({ length: laggingCapacitylength }, (_, index) => {
                            details.push({ value: 0, label: "Select..." })
                        })
                    }

                } else {
                    Array.from({ length: capacityDetails[0].room_capacity }, (_, index) => {
                        details.push({ value: 0, label: "Select..." })
                    })
                }


                this.setState({
                    roomSearch: value,
                    roomError: "",
                    capacityDetails: capacityDetails[0].capacity_details,
                    capacityCount: capacityDetails[0].room_capacity,
                    studentnameSearchval: details,
                    showInputFields: true,
                    multiStuSubmitError: "",
                    submitError: ""
                })
            } else {
                this.setState({
                    roomSearch: "",
                    roomError: "",
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false,
                    multiStuSubmitError: "",
                    submitError: ""
                })
            }
        }
    }

    getBuildingCreationDetails = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id: Int $branch_id: Int){
                getHostelBuildingsLite(institute_id: $institute_id branch_id:$branch_id) {
                    hostel_building_id
                    hostel_building_name
                    floors_details{
                      floor_id
                      floor_name
                      rooms_details{
                        room_id
                        room_name
                        room_capacity
                        capacity_details{
                          edu_student_id
                        }
                      }
                    }
                }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val)
            },
            fetchPolicy: 'network-only'
        })
        console.log("ttt", result.data.getHostelBuildingsLite);
        let filter_data = result.data.getHostelBuildingsLite || [];
        this.setState({
            getBuildings: filter_data,
            loadingSpin: 0
        })
    }

    // Students for the allocation dropdown — fetched from edu_students by
    // institute + branch (so every student of the branch is listed).
    // Returns a promise that resolves only AFTER studentFilterData is committed,
    // so callers (e.g. edit prefill) can safely read it right after.
    getAllotmentStudents = (branch_id) => {
        return new Promise(async (resolve) => {
            try {
                const result = await this.props.client.query({
                    query: gql`
                        query($institute_id: Int, $branch_id: Int){
                            getAllotmentStudents(institute_id: $institute_id, branch_id: $branch_id){
                                student_id
                                student_name
                                roll_no
                            }
                        }
                    `,
                    variables: {
                        institute_id: parseInt(Cookies.get("institutionid")),
                        branch_id: parseInt(branch_id),
                    },
                    fetchPolicy: 'network-only'
                });
                this.setState({ studentFilterData: result.data.getAllotmentStudents || [] }, resolve);
            } catch (err) {
                console.error("Error fetching allotment students:", err);
                this.setState({ studentFilterData: [] }, resolve);
            }
        });
    }

    // Resolve a student's display label, falling back across sources so a missing
    // record never crashes the prefill.
    studentLabel = (studentId) => {
        const s = this.state.studentFilterData.find((x) => x.student_id == studentId)
            || (this.props.getNewEducationalStudents || []).find((x) => x.student_id == studentId);
        return s ? `${s.student_name}(${s.roll_no})` : `#${studentId}`;
    }

    // handleStudentChange = (index) => (event) => {
    //     const selectedValue = event.target.value;
    //     let updatedSearchval = [];

    //     this.state.studentnameSearchval.map((item, i) => {
    //         if (index == i) {
    //             updatedSearchval.push({ edu_student_id: +selectedValue })
    //         } else {
    //             updatedSearchval.push({ ...item })
    //         }
    //     })

    //     this.setState({ studentnameSearchval: updatedSearchval, multiStuSubmitError: "", submitError: "" });

    // };



    handleStudentChange = (index, e) => {
        const selectedValue = e.value;
        let updatedSearchval = [];
        this.state.studentnameSearchval.map((item, i) => {
            if (index == i) {
                if (selectedValue != 0) {

                    let filterStudentsData = this.state.studentFilterData.find((item1) => item1.student_id == selectedValue);
                    updatedSearchval.push({ value: `${selectedValue}`, label: `${filterStudentsData.student_name}(${filterStudentsData.roll_no})` })
                } else {
                    updatedSearchval.push({ value: 0, label: "Select..." })

                }
            } else {
                updatedSearchval.push({ ...item })
            }
        })

        this.setState({ studentnameSearchval: updatedSearchval, multiStuSubmitError: "", submitError: "", noChangeMsg: "" });
    }

    handleSubmit = () => {
        if (this.state.branchSearch == "") {
            this.setState({
                branchError: "Please select Branch"
            })
            return ""
        }
        if (this.state.buildingSearch == "") {
            this.setState({
                buildingError: "Please select Building"
            })
            return ""
        }
        if (this.state.floorSearch == "") {
            this.setState({
                floorError: "Please select Floor"
            })
            return ""
        }
        if (this.state.roomSearch == "") {
            this.setState({
                roomError: "Please select Room"
            })
            return ""
        }

        // Edit mode: if the allocated students haven't changed, don't submit —
        // just inform the user.
        if (this.props.stateData.isEdit) {
            const original = [...new Set((this.state.capacityDetails || []).map((c) => String(c.edu_student_id)))].sort();
            const current = [...new Set(this.state.studentnameSearchval.filter((s) => s && s.value != 0).map((s) => String(s.value)))].sort();
            const unchanged = original.length === current.length && original.every((id, i) => id === current[i]);
            if (unchanged) {
                this.setState({ noChangeMsg: "No changes to update." });
                return "";
            }
        }
        this.setState({ noChangeMsg: "" });

        const uniqueStudentIds = new Set();
        let hasDuplicates = false;

        this.state.studentnameSearchval.forEach((item) => {
            if (item.value !== 0) {
                if (uniqueStudentIds.has(item.value)) {
                    hasDuplicates = true;
                    return;
                }
                uniqueStudentIds.add(item.value);
                console.log("uniqueStudentIds", uniqueStudentIds);
            }
        });

        if (hasDuplicates) {
            this.setState({
                multiStuSubmitError: "Please select unique students.",
                loadingSpin: 0
            });
            return;
        }

        const filteredStudentNames = this.state.studentnameSearchval.filter((item) => item.value !== 0);

        console.log("kkkk", filteredStudentNames);

        let students = [];

        filteredStudentNames.map((item) => {
            students.push({ edu_student_id: parseInt(item.value) })
        })
        const params = {
            room_id: parseInt(this.state.roomSearch),
            inserted_by: parseInt(Cookies.get("id")),
            room_capacity: students
        }


        this.setState({
            loadingSpin: 1
        })

        this.addStudentAllotmentDetails(
            params
        ).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpin: 0
            });

            console.error("ERR =>", error.graphQLErrors.map(x => x.message));

            if (error.graphQLErrors.map(x => x.extensions).length > 0 && error.graphQLErrors.map(x => x.extensions)[0].code == "BAD_USER_INPUT" && students.length > 0) {
                if (window.confirm(this.state.submitError)) {
                    this.studentConfirmAllotment();
                }
            }

        });


    }

    // Last gate before the student→room allotment write leaves the client.
    addStudentAllotmentDetails = async (
        params) => {
        if (!canEdit(HOSTEL_BUILDINGS_MODULE)) return;

        await this.props.addStudentAllotmentDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addStudentAllotmentDetails) {
                    this.setState({
                        loadingSpin: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        // Refresh the allocation list in place instead of reloading the page.
                        if (this.props.onSaved) this.props.onSaved();
                    }, 1000)
                }
            }

        });

    };


    //second confirm mutation
    studentConfirmAllotment = () => {
        const filteredStudentNames2 = this.state.studentnameSearchval.filter((item) => item.edu_student_id !== 0);
        let students2 = [];

        filteredStudentNames2.map((item) => {
            students2.push({ edu_student_id: parseInt(item.value) })
        })
        const params = {
            room_id: parseInt(this.state.roomSearch),
            inserted_by: parseInt(Cookies.get("id")),
            room_capacity: students2
        }
        this.setState({
            loadingSpin: 0
        })
        this.deleteExistingRoomStudents(
            params
        ).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpin: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));

        });

    }


    // Destructive, but NOT a user-facing delete button: it only runs as a sub-step of
    // re-allotting a room (studentConfirmAllotment clears the existing occupants first),
    // and it is reachable only from handleSubmit. So it is gated under is_edit, alongside
    // the allotment it belongs to, rather than is_delete.
    deleteExistingRoomStudents = async (
        params) => {
        if (!canEdit(HOSTEL_BUILDINGS_MODULE)) return;

        await this.props.deleteExistingRoomStudents({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.deleteExistingRoomStudents) {
                    this.setState({
                        loadingSpin: 0,
                        submitted: true
                    })
                    if (this.state.submitted == true) {
                        this.handleSubmit();
                    }
                    setTimeout(() => {
                        this.props.onHide();
                        // Refresh the allocation list in place instead of reloading the page.
                        if (this.props.onSaved) this.props.onSaved();
                    }, 1000)
                }
            }

        });

    };


    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            console.log("update");


            this.setState({
                dataClear: 1,
                branchSearch: "",
                branchError: "",
                buildingSearch: "",
                buildingError: "",
                floorSearch: "",
                floorError: "",
                roomSearch: "",
                roomError: "",
                studentFilterData: [],
                defaultvalue: 0,
                getBuildings: [],
                getFloors: [],
                getRooms: [],
                capacityDetails: [],
                capacityCount: 0,
                showInputFields: false,
                studentnameSearchval: [],
                submitError: "",
                submitted: false,
                multiStuSubmitError: "",
                noChangeMsg: "",
            })

            let existingModalDetails = this.props.stateData
            let getStudents = existingModalDetails.getStudentData;

            if (existingModalDetails.isEdit) {
                this.setState({
                    branchSearch: existingModalDetails.branchSearch,
                    buildingSearch: existingModalDetails.activeBuildingDetails.toString(),
                    floorSearch: existingModalDetails.activeFloorDetails.toString(),
                    roomSearch: existingModalDetails.activeRoomDetails.toString(),
                    capacityCount: existingModalDetails.activeCapacityDetails,
                    studentFilterData: [],
                    showInputFields: true,
                    getBuildings: existingModalDetails.getBuildingData,
                    getFloors: existingModalDetails.getFloorData,
                    getRooms: existingModalDetails.getRoomData,

                })
                // Load the branch's students FIRST, then build the room's bed
                // prefill — so the allocated students resolve to names (and never
                // crash on an undefined lookup).
                this.getAllotmentStudents(existingModalDetails.branchSearch).then(() => {
                    let e = {
                        target: {
                            name: "roomSearch",
                            value: existingModalDetails.activeRoomDetails.toString()
                        }
                    }
                    this.handleAllocationChange(e)
                })

            }
        }

        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }

    }

    render() {
        console.log("sssssssss", this.state);

        // Building options for the searchable single-select — newest building
        // (highest id) shown at the top.
        const buildingOptions = [...this.state.getBuildings]
            .sort((a, b) => b.hostel_building_id - a.hostel_building_id)
            .map((b) => ({ value: b.hostel_building_id, label: b.hostel_building_name }));
        const selectedBuilding = buildingOptions.find(
            (o) => String(o.value) === String(this.state.buildingSearch)) || null;

        const filteredStudent = this.state.studentnameSearchval.filter((item) => item.value !== 0);

        let studentArr = [];

        filteredStudent.map((item) => {
            studentArr.push({ edu_student_id: item.value })
        })

        let studentsData = [];

        if (this.state.studentFilterData.length > 0) {
            let obj = {
                label: "Select...",
                value: 0
            }
            studentsData.push(obj)

            this.state.studentFilterData.map((item) => {
                studentsData.push({ label: `${item.student_name}(${item.roll_no})`, value: item.student_id })
            })
        }
        return (
            <Modal
                {...this.props}
                className="bc-modal"
                dialogClassName="bc-modal-wide"
                aria-labelledby="contained-modal-title-vcenter"
            >

                <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)" }}>
                    <Modal.Header style={{ background: "#fff", borderBottom: "1px solid #f1f5f9", padding: "18px 24px" }}>
                        <Modal.Title style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", margin: 0 }}>
                            <span style={S.iconWrapperList}><i className="fal fa-users" /></span>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>
                                    {this.props.stateData.isEdit ? "Edit Student Allocation" : "New Student Allocation"}
                                </span>
                                <span style={{ fontSize: 12, fontWeight: 500, color: "#64748b", marginTop: 2 }}>
                                    Allocate students to hostel building, floor and room beds
                                </span>
                            </div>
                            <button type="button" aria-label="Close" onClick={this.props.onHide} style={S.modalClose}>&times;</button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "24px" }}>
                      <div style={S.modalCard}>
                        <Row>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={S.label}>Branch</label>
                                <Form.Control as="select" name="branchSearch" onChange={this.handleAllocationChange} value={this.state.branchSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                    <option value={this.state.defaultvalue}>--Select--</option>
                                    {this.props.globals.globalBranches.map(item => (
                                        <option value={item.id}>{item.branch_name}</option>
                                    ))}
                                </Form.Control>
                                {this.state.branchError && <div style={S.errText}>{this.state.branchError}</div>}
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={S.label}>Building Name</label>
                                <Select
                                    name="buildingSearch"
                                    options={buildingOptions}
                                    value={selectedBuilding}
                                    onChange={(opt) => this.handleAllocationChange({ target: { name: "buildingSearch", value: opt ? opt.value : "" } })}
                                    placeholder="Search building…"
                                    noOptionsMessage={() => "No buildings"}
                                    isClearable
                                    isDisabled={this.props.stateData.isEdit == true ? true : false}
                                    styles={buildingSelectStyles}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                    classNamePrefix="building-select"
                                />
                                {this.state.buildingError && <div style={S.errText}>{this.state.buildingError}</div>}
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={S.label}>Floor Name</label>
                                <Form.Control as="select" name="floorSearch" onChange={this.handleAllocationChange} value={this.state.floorSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                    <option value={this.state.defaultvalue}>--Select--</option>
                                    {this.state.getFloors.map(floorname => (
                                        <option value={floorname.floor_id}>{floorname.floor_name}</option>
                                    ))}
                                </Form.Control>
                                {this.state.floorError && <div style={S.errText}>{this.state.floorError}</div>}
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={S.label}>Room Number</label>
                                <Form.Control as="select" name="roomSearch" onChange={this.handleAllocationChange} value={this.state.roomSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                    <option value={this.state.defaultvalue}>--Select--</option>
                                    {this.state.getRooms.map(roomno => (
                                        <option value={roomno.room_id}>{roomno.room_name}</option>
                                    ))}
                                </Form.Control>
                                {this.state.roomError && <div style={S.errText}>{this.state.roomError}</div>}
                            </Col>
                        </Row>

                        {
                            this.state.showInputFields == true ? (
                                <div style={{ marginTop: 12, paddingTop: 18, borderTop: "1px dashed #e2e8f0" }}>
                                    <div className="d-flex align-items-center justify-content-between mb-2" style={{ flexWrap: "wrap", gap: 8 }}>
                                        <div style={S.sectionHead}><i className="fal fa-user-graduate mr-2" />Allocate Students</div>
                                        <span style={S.countChip}>{this.state.capacityCount} beds</span>
                                    </div>

                                    <div style={{ maxHeight: 320, overflowY: "auto", overflowX: "hidden", paddingRight: 4, marginRight: -4 }}>
                                    <Row>
                                        {[...Array(this.state.capacityCount)].map((_, index) => {
                                            // Hide students already chosen in the OTHER beds so the same
                                            // student can't be allocated twice. Keep the "Select..." option.
                                            const optionsForBed = studentsData.filter((o) => {
                                                if (o.value === 0) return true;
                                                const takenElsewhere = this.state.studentnameSearchval.some(
                                                    (s, i) => i !== index && s && String(s.value) === String(o.value)
                                                );
                                                return !takenElsewhere;
                                            });
                                            return (
                                                <Col key={index} lg={4} md={6} sm={12} className="mb-3">
                                                    <div style={{ background: "#f8fafc", border: "1px solid #eef2f7", borderRadius: 12, padding: "14px 16px" }}>
                                                        <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                                                            <span style={{ width: 26, height: 26, borderRadius: "50%", background: "#e0e7ff", color: "#4f46e5", fontSize: 12, fontWeight: 700, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{index + 1}</span>
                                                            <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Bed {index + 1}</span>
                                                        </div>
                                                        <Select
                                                            options={optionsForBed}
                                                            onChange={(e) => { this.handleStudentChange(index, e) }}
                                                            name="studentData"
                                                            value={this.state.studentnameSearchval[index]}
                                                            placeholder="Search student…"
                                                            noOptionsMessage={() => "No students"}
                                                            styles={studentSelectStyles}
                                                            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                                            classNamePrefix="student-select"
                                                        />
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                    </div>

                                    <div className="d-flex flex-column align-items-center mt-3">
                                        <Button style={{ ...S.submitBtn, width: "auto" }} onClick={this.handleSubmit}>
                                            {
                                                this.state.loadingSpin == 1 ? (
                                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                                ) : ""
                                            }
                                            {this.props.stateData.isEdit ? "Update Allocation" : "Submit"}</Button>
                                        <div className="mt-2 text-center">
                                            {
                                                this.state.submitted == true ? (
                                                    <span style={{ color: "#15803d", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "6px 14px", fontSize: 13, display: "inline-block" }}>{this.props.stateData.isEdit ? "Allocation updated successfully" : "Allocated successfully"}</span>
                                                ) : ""
                                            }
                                            {
                                                this.state.multiStuSubmitError != "" ? (
                                                    <span style={{ color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "6px 14px", fontSize: 13, display: "inline-block" }}>{this.state.multiStuSubmitError}</span>
                                                ) : ("")
                                            }
                                            {
                                                this.state.noChangeMsg ? (
                                                    <span style={{ color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, display: "inline-block" }}><i className="fal fa-info-circle mr-2" />{this.state.noChangeMsg}</span>
                                                ) : ("")
                                            }
                                            {
                                                this.state.submitError != "" && studentArr.length == 0 ? (
                                                    <span style={{ color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "6px 14px", fontSize: 13, display: "inline-block" }}>{this.state.submitError}</span>
                                                ) : ("")
                                            }
                                        </div>
                                    </div>
                                </div>
                            ) : ""
                        }
                      </div>
                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_STUDENT_ALLOTMENT_DETAILS, {

        name: "addStudentAllotmentDetails"
    }),
    graphql(DELETE_EXISTING_ROOM_STUDENTS, {

        name: "deleteExistingRoomStudents"
    }),
)(AddBuildingModal)));
